<div class="home-container">
  <div class="welcome-section">
    <h1>{{ 'home.welcome' | translate }}</h1>
    <!-- <p class="subtitle">{{ environment.client }} - Operator Dashboard</p> -->
  </div>

  <div class="links-grid">
    @for (link of homeLinks(); track link.id) {
    <mat-card class="link-card" [routerLink]="link.route">
      <mat-card-header>
        <mat-icon mat-card-avatar class="card-icon">{{ link.icon }}</mat-icon>
        <mat-card-title>{{ link.title | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ link.description | translate }}</p>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-button color="primary">
          {{ 'common.open' | translate }}
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
    }
  </div>

  @if (homeLinks().length === 0) {
  <mat-card class="no-access-card">
    <mat-card-content>
      <mat-icon>info</mat-icon>
      <p>{{ 'home.noAccess' | translate }}</p>
    </mat-card-content>
  </mat-card>
  }
</div>